import React, { useEffect, useContext, useState } from 'react';
import PropTypes from 'prop-types';
import {
  ForgeButton,
  ForgeScaffold,
  ForgeToolbar,
  ForgeDialog,
  ForgeIcon
} from '@tylertech/forge-react';
import Filters from './Filters.js';
import { FiltersContext } from './filterContext.js';
import { FILTERS } from '../../../static/keyWords.js';
import { getFilterNumberMessage } from './filterHelpers.js';
import { useUser } from '../../../contexts/userContext.js';
import './ReusableFilterDrawer.scss';

const EMPTY_PARAMS = {};

const ReusableFilterDrawer = ({ filters, tabbed, params = EMPTY_PARAMS }) => {
  const { user } = useUser();
  const [stringifiedActiveOrganization] = useState(JSON.stringify(user?.activeOrganization));
  const [stringifiedActiveCostCenters] = useState(JSON.stringify(user?.activeCostCenters));

  const {
    settings,
    appliedFilters,
    innerAppliedFilters,
    setInnerAppliedFilters,
    numOfAppliedFilters,
    setTagFilterNames,
    handleApplyFilters,
    openFilters,
    setOpenFilters,
    isLinked,
    setIsLinked,
    clearAllFilters,
    resetFilters,
    setParams,
    setRefresh,
    handleCloseDrawer,
  } = useContext(FiltersContext);

  useEffect(() => {
    setTagFilterNames(filters);
    setParams(params);
  }, [tabbed && filters, user?.activeOrganization]);

  useEffect(() => {
    const stringifyStateActiveOrganization = JSON.stringify(user?.activeOrganization);
    const stringifyStateActiveCostCenters = JSON.stringify(user?.activeCostCenters);

    const isActiveOrganizationChanged = stringifiedActiveOrganization !== stringifyStateActiveOrganization;
    const areActiveCostCentersChanged = stringifiedActiveCostCenters !== stringifyStateActiveCostCenters;

    if (isActiveOrganizationChanged || areActiveCostCentersChanged) resetFilters();
  }, [user?.activeOrganization, user?.activeCostCenters]);

  return (
    <ForgeDialog
      preset="right-sheet"
      open={openFilters}
      className="filters-drawer"
      slot="body-right"
      variant="raised"
      on-forge-dialog-close={() => handleCloseDrawer(true)}
    >
      <ForgeScaffold>
        <ForgeToolbar slot={'header'}>
          <h2 slot="start" className="forge-typography--heading4">
            {FILTERS}
          </h2>
          <ForgeIcon
            slot="end"
            name="close"
            onClick={() => setOpenFilters(false)}
            style={{ cursor: 'pointer' }}
            className="defaultIconColor"
          />
        </ForgeToolbar>
        <div slot="body" className="filters-drawer-content">
          <div className="filters-drawer-content-header">
            <span className="filters-message">
              {getFilterNumberMessage(numOfAppliedFilters)}
            </span>
            <ForgeButton onClick={clearAllFilters}>
              Reset all
            </ForgeButton>
          </div>

          <Filters
            settings={settings}
            appliedFilters={appliedFilters}
            innerAppliedFilters={innerAppliedFilters}
            setInnerAppliedFilters={setInnerAppliedFilters}
            filterLabelsParams={params}
            isLinked={isLinked}
            setIsLinked={setIsLinked}
            setRefresh={setRefresh}
          />
        </div>
        <ForgeToolbar slot="footer" inverted>
          <ForgeButton
            slot="end"
            variant="filled"
            onClick={handleApplyFilters}
          >
            Apply filters
          </ForgeButton>
        </ForgeToolbar>
      </ForgeScaffold>
    </ForgeDialog>
  );
};

ReusableFilterDrawer.propTypes = {
  filters: PropTypes.array,
  tabbed: PropTypes.bool,
  params: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
};

export default ReusableFilterDrawer;
